'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
type DismissReviewDialogProps = {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onDismiss: (reason: string) => void;
};
export function DismissReviewDialog(t0) {
  const $ = _c(25);
  const {
    isOpen,
    onOpenChange,
    onDismiss
  } = t0;
  const [dismissReason, setDismissReason] = useState("");
  let t1;
  if ($[0] !== onOpenChange) {
    t1 = open => {
      if (!open) {
        setDismissReason("");
      }
      onOpenChange(open);
    };
    $[0] = onOpenChange;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleOpenChange = t1;
  let t2;
  if ($[2] !== dismissReason || $[3] !== onDismiss || $[4] !== onOpenChange) {
    t2 = () => {
      if (!dismissReason.trim()) {
        return;
      }
      onDismiss(dismissReason);
      setDismissReason("");
      onOpenChange(false);
    };
    $[2] = dismissReason;
    $[3] = onDismiss;
    $[4] = onOpenChange;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const handleDismiss = t2;
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <DialogHeader><DialogTitle>Dismiss review</DialogTitle></DialogHeader>;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== handleDismiss) {
    t4 = event => {
      event.preventDefault();
      handleDismiss();
    };
    $[7] = handleDismiss;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Label htmlFor="reason">Reason</Label>;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = e => setDismissReason(e.target.value);
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== dismissReason) {
    t7 = <div className="grid items-center gap-4 py-4">{t5}<Input id="reason" value={dismissReason} onChange={t6} placeholder="Enter reason for dismissing the review" className="col-span-3" /></div>;
    $[11] = dismissReason;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== dismissReason) {
    t8 = dismissReason.trim();
    $[13] = dismissReason;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const t9 = !t8;
  let t10;
  if ($[15] !== t9) {
    t10 = <DialogFooter><Button type="submit" size="sm" disabled={t9}>Dismiss</Button></DialogFooter>;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10 || $[18] !== t4 || $[19] !== t7) {
    t11 = <DialogContent className="sm:max-w-[425px]" aria-describedby={undefined}>{t3}<form onSubmit={t4}>{t7}{t10}</form></DialogContent>;
    $[17] = t10;
    $[18] = t4;
    $[19] = t7;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== handleOpenChange || $[22] !== isOpen || $[23] !== t11) {
    t12 = <Dialog open={isOpen} onOpenChange={handleOpenChange}>{t11}</Dialog>;
    $[21] = handleOpenChange;
    $[22] = isOpen;
    $[23] = t11;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  return t12;
}